import { render } from "./NotFound.vue?vue&type=template&id=d2fd3210&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=d2fd3210&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d2fd3210"

export default script